module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightmodsnow-8b99f0d6088649cd6eeafdf3465e71ef.svg";